
<template>
  <div
    ref="playerContaine"
    :class="['flv-player', { 'flv-playing': isPlaying }]"
  ></div>
</template>

<script>
import flvjs from "flv.js";

export default {
  data() {
    return {
      flvPlayer: null,
      isPlaying: false,
    };
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.initFlvPlayer();
  },
  beforeDestroy() {
    this.destroyFlvPlayer();
  },
  methods: {
    initFlvPlayer() {
      const { options, url } = this;
      const { autoplay = false, controls = true } = options;
      const flvOptions = Object.assign({}, options, {
        isLive: true, // 指定为直播类型
      });
      const playerContainer = this.$refs.playerContainer;

      if (flvjs.isSupported()) {
        const flvPlayer = (this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          url,
          ...flvOptions,
        }));

        flvPlayer.attachMediaElement(playerContainer);
        flvPlayer.load();

        if (autoplay) {
          flvPlayer.play().catch((err) => {
            console.error("Failed to start flv player:", err);
          });
        }

        this.isPlaying = flvPlayer.isPaused(); // 播放状态
      } else {
        console.error("FLV.js is not support.");
      }
    },
    destroyFlvPlayer() {
      if (this.flvPlayer) {
        this.flvPlayer.unload();
        this.flvPlayer.detachMediaElement();
      }
    },
  },
};
</script>



